import { BRAND_FILTER_DEFINITIONS, RESPONSE_KEY_TO_CANONICAL } from './brandFilterDefinitions'

/**
 * Display helpers for a watchlist's criteria history (GET /api/watchlists/{id}/versions).
 */

// Filter keys reach the client either canonical (a change's `label` is a plain string value, so
// the response transform leaves it alone) or camelCased (keys inside a snapshot's `filters`
// object are transformed) — both resolve to the same filter definition here.
export const describeFilterLabel = (key, tFilters) => {
  const canonical = RESPONSE_KEY_TO_CANONICAL[key] ?? key
  const definition = BRAND_FILTER_DEFINITIONS.find(item => item.attribute === canonical || item.key === key)

  if (definition) return tFilters(definition.labelKey)
  if (canonical === 'query') return tFilters('Filter.query.label')
  return canonical
}

export const describeFilterValue = value => {
  if (value === null || value === undefined) return ''
  return Array.isArray(value) ? value.join(', ') : String(value)
}

/**
 * One line for one entry of a version's `changes[]`
 * ({ op: added|removed|changed, kind, label, from, to }).
 */
export const describeHistoryChange = (change, { t, tFilters }) => {
  switch (change.kind) {
    case 'brand':
    case 'presentation':
    case 'fav_group':
      return t(`History.change.${change.kind}.${change.op}`, { label: change.label })
    case 'fav_group_items':
      // For a changed group, `from` is how many items left it and `to` how many joined.
      return t('History.change.fav_group_items', { label: change.label, added: change.to, removed: change.from })
    case 'filter':
      return t(`History.change.filter.${change.op}`, {
        label: describeFilterLabel(change.label, tFilters),
        from: describeFilterValue(change.from),
        to: describeFilterValue(change.to)
      })
    default:
      return String(change.label ?? '')
  }
}
